export default "__VITE_ASSET__Bv7ZNs3F__"